import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { IOwnerObject } from "../../../../services/api.types";

interface DeleteOwnerDialogProps {
  open: boolean;
  owner: IOwnerObject | null;
  onConfirm: () => void;
  onCancel: () => void;
  loading?: boolean;
}

// Modelled directly on
// ../../Owner/screens/components/DeleteCarWashDialog.tsx — same prop shape,
// same structure. Deleting an owner is high-consequence (cascades to the
// owner's car washes and employees), so the confirmation copy calls that out
// explicitly rather than reusing the generic car-wash confirmation text.
const DeleteOwnerDialog = ({
  open,
  owner,
  onConfirm,
  onCancel,
  loading = false,
}: DeleteOwnerDialogProps) => {
  const { t } = useTranslation();
  const fullName = owner ? `${owner.firstName} ${owner.lastName}` : "";
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      aria-labelledby="delete-owner-dialog-title"
      aria-describedby="delete-owner-dialog-description"
    >
      <DialogTitle id="delete-owner-dialog-title">
        {t("common.confirmDelete")}
      </DialogTitle>
      <DialogContent>
        <Typography>
          {t("ownerScreens.deleteOwnerConfirm", { name: fullName })}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          {t("common.actionCannotBeUndone")}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="primary" disabled={loading}>
          {t("common.cancel")}
        </Button>
        <Button
          onClick={onConfirm}
          color="error"
          variant="contained"
          disabled={loading}
        >
          {loading ? t("common.deleting") : t("common.delete")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteOwnerDialog;
